<template>
  <div class="Login">
    <br>
    <div class="columns">
      <div class="column">
        
      </div>
      <div class="column">


    <div class="card">
      <header class="card-header">
        <p class="card-header-title">
          Login
        </p>
        <a href="#" class="card-header-icon" aria-label="more options">
          <span class="icon">
            <i class="fas fa-angle-down" aria-hidden="true"></i>
          </span>
        </a>
      </header>
      <div class="card-content">
        <div class="content">
          <!--content-->
          <div class="field">
            <p class="control has-icons-left has-icons-right">
              <input class="input" type="email" placeholder="Email" @keyup.enter="login" v-model="credential.user" id="login" name="login">
              <span class="icon is-small is-left">
                <i class="fas fa-envelope"></i>
              </span>
              <span class="icon is-small is-right">
                <i class="fas fa-check"></i>
              </span>
            </p>
          </div>
          <div class="field">
            <p class="control has-icons-left">
              <input class="input" type="password" placeholder="Password" @keyup.enter="login" v-model="credential.pass" id="password" name="password">
              <span class="icon is-small is-left">
                <i class="fas fa-lock"></i>
              </span>
            </p>
            
          </div>
          <button v-if="saving == false" v-on:click="login" class="button is-small">Zatwierdź</button>
          <button v-else class="button is-small is-loading">Zatwierdź</button>
          <!--content-->
        </div>
      </div>

      
    </div>
        </div>
      <div class="column">
        
      </div>
      
    </div>
   </div>
</template>

<script>
    export default {
        data() {
            return {
                credential: {
                    user:'',
                    pass:''
                },
                saving: false
            }
            
        },
        methods: {
            login() {
              this.saving = true;
                this.$store.dispatch('login', this.credential)
                .then(response => {
                  
                  if (response == "Error"){
                    
                    this.saving = false;
                    //this.$router.push({ path: '/login' });
                  }else{
                    
                    this.saving = false;
                    this.$router.push({ path: '/' });
                    
                  }
                  
                })
                .catch(error => {
                    console.log(error)
                    //this.$router.push({ path: '/login' });
                });
                
                
                
            }
        },
        created: function () {

        }
    }
</script>
<style scope>
  .form{
    width: 300px;
  }
</style>
